import React from 'react'
import { FormDisplayErrors } from '@myxplor/forms'

export const RemoveDraftEnrolmentFields = () => (
  <fieldset>Removing this draft will cause it to no longer appear.
    The data is still kept in the system for auditing purposes.</fieldset>
)

export const RemoveDraftEnrolmentDone = ({ errors = [] }) =>
  errors.length > 0 ? (
    <fieldset>
      There was an error removing your draft enrolment...
      <FormDisplayErrors errors={errors} />
    </fieldset>
  ) : (
    <fieldset>The draft enrolment was successfully removed</fieldset>
  )



// WEBPACK FOOTER //
// ./src/care-enrolments/details/ccs-gov-enrolments/actions/remove-draft-enrolment/fields.jsx